import "core-js/modules/es6.object.keys";
import "core-js/modules/web.dom.iterable";
//
//
//
//
//
//

import Vue from 'vue';
import * as filters from "./utils/filters";
Object.keys(filters).forEach(function (key) {
  return Vue.filter(key, filters[key]);
});
import * as diction from "./utils/diction";
Vue.prototype.DICTION = diction;
export default {
  name: 'App'
};